import { Facebook, Instagram, Youtube } from "lucide-react";
import { LogoMark, scrollToId } from "./decor";
import { EmailReveal } from "./EmailReveal";
import { NAV_LINKS, SOCIALS } from "../data/siteData";
import { useLang } from "../i18n";

const ICONS = { facebook: Facebook, instagram: Instagram, youtube: Youtube };

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-800 bg-[#0A0A0C]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-10">
          <div>
            <div className="flex items-center gap-3">
              <LogoMark size={30} />
              <img src="/crayfox-wordmark.png" alt="CRAYFOX" className="h-9 w-auto" />
            </div>
            <p className="mt-3 font-mono-tech text-xs tracking-[0.25em] uppercase text-zinc-500">
              {t.footer.tagline}
            </p>
            <EmailReveal testId="footer-email-me" />
          </div>

          <div className="flex flex-col items-start md:items-end gap-5">
            <div className="flex gap-3">
              {SOCIALS.map((s) => {
                const Icon = ICONS[s.id];
                return (
                  <a
                    key={s.id}
                    data-testid={`social-${s.id}-link`}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`CRAYFOX on ${s.label}`}
                    className="h-11 w-11 flex items-center justify-center border border-zinc-800 text-zinc-400 hover:border-red-600 hover:text-red-500 hover:-translate-y-0.5 transition-all duration-300"
                  >
                    {Icon ? <Icon size={18} /> : <span className="font-display text-lg tracking-wider leading-none">{s.text}</span>}
                  </a>
                );
              })}
            </div>
            <nav className="flex flex-wrap gap-x-6 gap-y-2">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => scrollToId(l.id)}
                  className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-zinc-500 hover:text-white transition-colors duration-300"
                >
                  {t.nav[l.id]}
                </button>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-zinc-900 flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-zinc-600">
            {t.footer.rights}
          </p>
          <p className="font-mono-tech text-[11px] tracking-[0.2em] uppercase text-zinc-600">
            {t.footer.genre}
          </p>
        </div>
      </div>
    </footer>
  );
};
